import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Add_User from "./Add_User";
import type { User } from "@/types/user";
import { useTenantUserById } from "@/hooks/useTenantDashboardService";
import { Box, Button } from "@mui/material";
import { useUserStore } from "@/store";
import { useDashboardTheme } from "@/pages/MeetingDashboard/themeHelper";

const UserFormPage = () => {
  const { isDark } = useDashboardTheme();
  const { id } = useParams<{ id: string }>();
  const [editUserData, setEditUserData] = useState<User | null>(null);
  const { setPageHeader } = useUserStore();
  const isNewUser = id === "new";
  const navigate = useNavigate();
  const { data: fetchedUser, isLoading, isError } = useTenantUserById(id || "");

  useEffect(() => {
    if (fetchedUser) {
      setEditUserData(fetchedUser);
    }
  }, [fetchedUser]);
  
  useEffect(() => {
    setPageHeader(isNewUser ? "Add New User" : "Edit User");
  }, [isNewUser, setPageHeader]);
  
  if (!isNewUser && isLoading)
    return <div className="text-white">Loading...</div>;
  if (!isNewUser && isError)
    return <div className="text-red-500">Failed to load user.</div>;

  return (
    <div className={"min-h-screen p-6 mt-7 " + (isDark ? "bg-black text-white" : "light-theme-dashboard")} style={{ background: isDark ? "" : "#F4F5F7" }}>
      <h1 className="text-2xl font-bold mb-6">
        {isNewUser ? "Add New User" : "Edit User"}
      </h1>
      <Box display="flex" justifyContent="flex-end" mt={1} mb={2}>
        <Button
          onClick={() => navigate("/users")}
          sx={{
            width: "fit-content",
            backgroundColor: "#C1FF72",
            color: "#000",
            fontWeight: "bold",
            borderRadius: 999,
            px: 3,
            py: 1,
            textTransform: "none",
            "&:hover": { backgroundColor: "#D7FF9B" },
          }}
        >
          Go Back
        </Button>
      </Box>
      <Add_User
        onClose={() => {
          navigate("/users");
        }}
        editUserData={isNewUser ? null : editUserData}
        companyinfo={false}
      />
    </div>
  );
};

export default UserFormPage;
